import Page from "webPage/Page";
import Resources from "util/Resources";

Page.register('post-type-archive-resources', () => {

    let $resources = $('.js-resources');
    if ($resources.length > 0) {
        new Resources($resources);
    }
});
